<template>
  <div class="app-container">
    <!-- 顶部操作栏 -->
    <div class="operation-container mb20">
      <el-card shadow="never">
        <el-row :gutter="20" type="flex" align="middle">
          <el-col :span="12">
            <h3 style="margin: 0; color: #333;">应急小组</h3>
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">
              提示：在部门框中点击鼠标"右键"可以进行编辑
            </div>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-button type="primary" size="small" @click="handleAddTopDepartment">
              <i class="el-icon-plus"></i> 添加顶级部门
            </el-button>
            <el-button type="success" size="small" @click="handleAddEmployee">
              <i class="el-icon-plus"></i> 添加人员
            </el-button>
            <el-button type="danger" size="small" @click="handleBatchDelete" :disabled="selectedIds.length === 0">
              <i class="el-icon-delete"></i> 批量删除
            </el-button>
          </el-col>
        </el-row>
      </el-card>
    </div>

    <!-- 主内容区 -->
    <el-card shadow="never">
      <!-- 公司名称 -->
      <div class="company-header mb30">
        <h2 class="company-title">安安智运</h2>
        <div class="company-actions">
          <!-- <el-button type="text" size="small" @click="editCompanyInfo">
            <i class="el-icon-edit"></i> 编辑公司信息
          </el-button> -->
        </div>
      </div>

      <!-- 分割线 -->
      <el-divider></el-divider>

      <!-- 组织架构树 -->
      <div class="organization-tree">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading-container">
          <i class="el-icon-loading"></i> 加载中...
        </div>

        <!-- 树形结构 -->
        <div v-else-if="departmentTree.length > 0" class="tree-container">
          <div 
            v-for="department in departmentTree" 
            :key="department.ma_depart_id"
            class="department-item"
          >
            <!-- 部门/小组 -->
            <div 
              class="department-card"
              :class="{ 'is-top': department.parent_id === 0 }"
              @contextmenu.prevent="showContextMenu($event, department)"
            >
              <div class="department-header">
                <div class="department-title">
                  <i class="el-icon-office-building" v-if="department.parent_id === 0"></i>
                  <i class="el-icon-s-management" v-else></i>
                  <span class="department-name">{{ department.name }}</span>
                  <el-tag size="mini" type="info">{{ department.employeeCount || 0 }}人</el-tag>
                </div>

                <div class="department-actions">
                  <el-button 
                    type="text" 
                    size="mini" 
                    @click="handleEditDepartment(department)"
                    title="编辑部门"
                  >
                    <i class="el-icon-edit"></i>
                  </el-button>
                  <el-button 
                    type="text" 
                    size="mini" 
                    @click="handleAddSubDepartment(department)"
                    title="添加子部门"
                  >
                    <i class="el-icon-circle-plus"></i>
                  </el-button>
                  <el-button 
                    type="text" 
                    size="mini" 
                    @click="handleAddEmployee(department)"
                    title="添加人员"
                  >
                    <i class="el-icon-user-solid"></i>
                  </el-button>
                  <el-button 
                    type="text" 
                    size="mini" 
                    @click="handleDepartmentDetail(department)"
                    title="部门详情"
                  >
                    <i class="el-icon-document"></i>
                  </el-button>
                  <el-button 
                    type="text" 
                    size="mini" 
                    @click="handleDeleteDepartment(department)"
                    title="删除部门"
                    style="color: #F56C6C;"
                  >
                    <i class="el-icon-delete"></i>
                  </el-button>
                </div>
              </div>

   
              <!-- 员工列表 -->
              <div class="employee-list" v-if="department.employees && department.employees.length > 0">
                <div 
                  v-for="employee in department.employees" 
                  :key="employee.ma_employee_id"
                  class="employee-item"
                >
                  <div class="employee-info">
            
                    <div class="employee-details">
                      <div class="employee-name">{{ employee.name }}</div>
                      <div class="employee-meta">
                        <span class="employee-position">{{ employee.position }}</span>
                        <span class="employee-phone" v-if="employee.phone">
                          <i class="el-icon-phone"></i> {{ employee.phone }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="employee-actions">
                    <el-button type="text" size="mini" @click="handleEditEmployee(employee)">
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button 
                      type="text" 
                      size="mini" 
                      @click="handleViewEmployeeDetail(employee)"
                      title="查看详情"
                    >
                      <i class="el-icon-view"></i>
                    </el-button>
                    <el-button 
                      type="text" 
                      size="mini" 
                      @click="handleDeleteEmployee(employee)"
                      style="color: #F56C6C;"
                      title="删除"
                    >
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </div>
                </div>
              </div>
              <div v-else class="no-employees">
                暂无员工
                <el-button type="text" size="mini" @click="handleAddEmployee(department)">
                  添加员工
                </el-button>
              </div>
              
              <!-- 子部门列表 -->
              <div v-if="department.children && department.children.length > 0" class="sub-department-list">
                <div 
                  v-for="child in department.children" 
                  :key="child.ma_depart_id"
                  class="sub-department"
                >
                <div>
                    <div class="sub-department-content">
                    <i class="el-icon-folder-opened"></i>
                    <span class="sub-department-name">{{ child.name }}</span>
                    <el-tag size="mini" type="info">{{ child.employeeCount || 0 }}人</el-tag>
                  </div>



                  <div class="sub-department-actions">
                    <el-button type="text" size="mini" @click="handleEditDepartment(child)">
                      <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button type="text" size="mini" @click="handleAddEmployee(child)">
                      <i class="el-icon-user-solid"></i>
                    </el-button>
                  </div>

                </div>

                <div class="employee-list" v-if="child.employees && child.employees.length > 0">
                  <div 
                    v-for="employeex in child.employees" 
                    :key="employeex.ma_employee_id"
                    class="employee-item"
                  >
                    <div class="employee-info">
       
                      <div class="employee-details">
                        <div class="employee-name">{{ employeex.name }}</div>
                        <div class="employee-meta">
                          <span class="employee-position">{{ employeex.position }}</span>
                          <span class="employee-phone" v-if="employeex.phone">
                            <i class="el-icon-phone"></i> {{ employeex.phone }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="employee-actions">
                      <el-button type="text" size="mini" @click="handleEditEmployee(employeex)">
                        <i class="el-icon-edit"></i>
                      </el-button>
                      <el-button 
                        type="text" 
                        size="mini" 
                        @click="handleViewEmployeeDetail(employeex)"
                        title="查看详情"
                      >
                        <i class="el-icon-view"></i>
                      </el-button>
                      <el-button 
                        type="text" 
                        size="mini" 
                        @click="handleDeleteEmployee(employeex)"
                        style="color: #F56C6C;"
                        title="删除"
                      >
                        <i class="el-icon-delete"></i>
                      </el-button>
                    </div>
                  </div>
                </div>
                <div v-else class="no-employees">
                  暂无员工
                  <el-button type="text" size="mini" @click="handleAddEmployee(child)">
                    添加员工
                  </el-button>
                </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-else class="empty-container">
          <el-empty description="暂无应急小组数据">
            <el-button type="primary" size="small" @click="handleAddTopDepartment">添加第一个部门</el-button>
          </el-empty>
        </div>
      </div>
    </el-card>

    <!-- 右键菜单 -->
    <ul 
      v-show="contextMenu.visible"
      class="context-menu"
      :style="{
        left: contextMenu.x + 'px',
        top: contextMenu.y + 'px'
      }"
    >
      <li @click="handleContextEdit">编辑部门</li>
      <li @click="handleContextDelete">删除部门</li>
      <li @click="handleContextAddSub">添加子部门</li>
      <li @click="handleContextAddEmployee">添加人员</li>
      <li @click="handleContextDetail">部门详情</li>
    </ul>

    <!-- 添加/编辑部门弹窗 -->
    <el-dialog
      :title="departmentDialog.title"
      :visible.sync="departmentDialog.visible"
      width="500px"
      @close="closeDepartmentDialog"
    >
      <el-form 
        ref="departmentForm" 
        :model="departmentForm" 
        :rules="departmentRules" 
        label-width="100px"
        size="small"
      >
        <el-form-item label="上级部门" prop="parent_id" v-if="!departmentDialog.isEdit || departmentForm.parent_id !== 0">
          <el-cascader
            v-model="departmentForm.parent_id"
            :options="departmentOptions"
            :props="{
              value: 'ma_depart_id',
              label: 'name',
              children: 'children',
              checkStrictly: true,
              emitPath: false
            }"
            clearable
            placeholder="请选择上级部门（不选则为顶级部门）"
            style="width: 100%;"
          />
        </el-form-item>

        <el-form-item label="部门名称" prop="name" required>
          <el-input 
            v-model="departmentForm.name" 
            placeholder="请输入部门/小组名称"
          />
        </el-form-item>

        <el-form-item label="部门描述" prop="remark">
          <el-input 
            v-model="departmentForm.remark" 
            type="textarea"
            :rows="3"
            placeholder="请输入部门描述/职能"
          />
        </el-form-item>

        <el-form-item label="是否隐藏" prop="is_hide">
          <el-switch
            v-model="departmentForm.is_hide"
            :active-value="1"
            :inactive-value="0"
            active-text="隐藏"
            inactive-text="显示"
          />
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input-number 
            v-model="departmentForm.sort" 
            :min="0" 
            :max="999"
            controls-position="right"
            style="width: 120px;"
          />
          <span style="color: #909399; margin-left: 10px;">数字越小越靠前</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDepartmentDialog">取消</el-button>
        <el-button type="primary" @click="submitDepartmentForm" :loading="departmentDialog.loading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 部门详情弹窗 -->
    <el-dialog
      title="部门详情"
      :visible.sync="detailDialog.visible"
      width="600px"
    >
      <div class="department-detail-container" v-if="detailDialog.data">
        <div class="detail-section">
          <h3 class="detail-title">基本信息</h3>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="部门名称">{{ detailDialog.data.name }}</el-descriptions-item>
            <el-descriptions-item label="部门ID">{{ detailDialog.data.ma_depart_id }}</el-descriptions-item>
            <el-descriptions-item label="上级部门" :span="2">
              {{ detailDialog.data.parent_name || '顶级部门' }}
            </el-descriptions-item>
            <el-descriptions-item label="是否隐藏">
              <el-tag :type="detailDialog.data.is_hide ? 'danger' : 'success'" size="small">
                {{ detailDialog.data.is_hide ? '已隐藏' : '显示中' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="排序">{{ detailDialog.data.sort }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="detail-section" v-if="detailDialog.data.remark">
          <h3 class="detail-title">部门描述</h3>
          <div class="remark-content">
            {{ detailDialog.data.remark }}
          </div>
        </div>

        <div class="detail-section" v-if="detailDialog.data.intro">
          <h3 class="detail-title">详细介绍</h3>
          <div class="intro-content">
            {{ detailDialog.data.intro }}
          </div>
        </div>

        <div class="detail-section" v-if="detailDialog.data.create_time">
          <h3 class="detail-title">时间信息</h3>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="创建时间">
              {{formatTime(detailDialog.data.create_time)}}
            </el-descriptions-item>
            <el-descriptions-item label="更新时间">
              {{ formatTime(detailDialog.data.update_time) }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialog.visible = false">关闭</el-button>
        <el-button type="primary" @click="handleEditDepartment(detailDialog.data)">编辑</el-button>
      </div>
    </el-dialog>

    <!-- 添加/编辑员工弹窗 -->
    <el-dialog
      :title="employeeDialog.title"
      :visible.sync="employeeDialog.visible"
      width="700px"
      @close="closeEmployeeDialog"
    >
      <el-form 
        ref="employeeForm" 
        :model="employeeForm" 
        :rules="employeeRules" 
        label-width="100px"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属部门" prop="ma_depart_id" required>
              <el-select
                v-model="employeeForm.ma_depart_id"
                placeholder="请选择所属部门"
                clearable
                filterable
                style="width: 100%;"
              >
                <el-option
                  v-for="dept in allDepartments"
                  :key="dept.ma_depart_id"
                  :label="dept.name"
                  :value="dept.ma_depart_id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="所属岗位" prop="ma_position_id" required>
              <el-select
                v-model="employeeForm.ma_position_id"
                placeholder="请选择所属部门"
                clearable
                filterable
                style="width: 100%;"
              >
                <el-option
                  v-for="dept in allPosition"
                  :key="dept.ma_position_id"
                  :label="dept.name"
                  :value="dept.ma_position_id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="员工姓名" prop="name" required>
              <el-input v-model="employeeForm.name" placeholder="请输入员工姓名" />
            </el-form-item>

            <el-form-item label="性别" prop="gender">
              <el-radio-group v-model="employeeForm.gender">
                <el-radio :label="0">未知</el-radio>
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="手机号" prop="phone" required>
              <el-input v-model="employeeForm.phone" placeholder="请输入手机号" />
            </el-form-item>

            <el-form-item label="身份证号" prop="id_card">
              <el-input v-model="employeeForm.id_card" placeholder="请输入身份证号" />
            </el-form-item>

            <el-form-item label="出生日期" prop="birthday">
              <el-date-picker
                v-model="employeeForm.birthday"
                type="date"
                placeholder="选择出生日期"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              />
            </el-form-item>

            <el-form-item label="邮箱" prop="email">
              <el-input v-model="employeeForm.email" placeholder="请输入邮箱" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="政治面貌" prop="political_status">
              <el-select v-model="employeeForm.political_status" placeholder="请选择政治面貌" style="width: 100%;">
                <el-option label="群众" value="群众" />
                <el-option label="共青团员" value="共青团员" />
                <el-option label="中共党员" value="中共党员" />
                <el-option label="中共预备党员" value="中共预备党员" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>

             <el-form-item label="业务领域" prop="business_areas">
          <el-input 
            v-model="employeeForm.business_areas" 
            type="textarea"
            :rows="2"
            placeholder="请输入负责的业务领域/职位"
          />
        </el-form-item>

            <el-form-item label="地址" prop="address">
              <el-input 
                v-model="employeeForm.address" 
                type="textarea"
                :rows="2"
                placeholder="请输入地址"
              />
            </el-form-item>

            <el-form-item label="紧急联系人" prop="emergency_contact">
              <el-input v-model="employeeForm.emergency_contact" placeholder="请输入紧急联系人姓名" />
            </el-form-item>

            <el-form-item label="紧急电话" prop="emergency_phone">
              <el-input v-model="employeeForm.emergency_phone" placeholder="请输入紧急联系电话" />
            </el-form-item>

            <el-form-item label="业务领域" prop="business_areas">
              <el-input 
                v-model="employeeForm.business_areas" 
                type="textarea"
                :rows="2"
                placeholder="请输入负责的业务领域"
              />
            </el-form-item>

            <el-form-item label="状态" prop="status">
              <el-select v-model="employeeForm.status" placeholder="请选择状态" style="width: 100%;">
                <el-option label="在职" :value="1" />
                <el-option label="已离职" :value="2" />
              </el-select>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input-number 
                v-model="employeeForm.sort" 
                :min="0" 
                :max="999"
                controls-position="right"
                style="width: 120px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeEmployeeDialog">取消</el-button>
        <el-button type="primary" @click="submitEmployeeForm" :loading="employeeDialog.loading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 员工详情弹窗 -->
    <el-dialog
      title="员工详情"
      :visible.sync="employeeDetailDialog.visible"
      width="700px"
    >
      <div class="employee-detail-container" v-if="employeeDetailDialog.data">
        <div class="employee-header">
        
          <div class="employee-header-info">
            <h3 class="employee-detail-name">{{ employeeDetailDialog.data.name }}</h3>
            <div class="employee-detail-position">{{ employeeDetailDialog.data.position || '暂无职位' }}</div>
            <div class="employee-detail-department">
              <i class="el-icon-office-building"></i>
              {{ employeeDetailDialog.data.department_name || '未分配部门' }}
            </div>
          </div>
        </div>

        <el-tabs v-model="employeeDetailDialog.activeTab">
          <el-tab-pane label="基本信息" name="basic">
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="员工ID">{{ employeeDetailDialog.data.ma_employee_id }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <el-tag :type="employeeDetailDialog.data.status === 1 ? 'success' : 'info'" size="small">
                  {{ employeeDetailDialog.data.status === 1 ? '在职' : '已离职' }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="性别">
                {{ {0: '未知', 1: '男', 2: '女'}[employeeDetailDialog.data.gender] }}
              </el-descriptions-item>
              <el-descriptions-item label="所属岗位">
                {{ getPositionName(employeeDetailDialog.data.ma_position_id) || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="手机号">{{ employeeDetailDialog.data.phone || '-' }}</el-descriptions-item>
              <el-descriptions-item label="身份证号">{{ employeeDetailDialog.data.id_card || '-' }}</el-descriptions-item>
              <el-descriptions-item label="出生日期">{{ employeeDetailDialog.data.birthday || '-' }}</el-descriptions-item>
              <el-descriptions-item label="政治面貌">{{ employeeDetailDialog.data.political_status || '-' }}</el-descriptions-item>
              <el-descriptions-item label="邮箱">{{ employeeDetailDialog.data.email || '-' }}</el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>

          <el-tab-pane label="联系信息" name="contact">
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="地址">{{ employeeDetailDialog.data.address || '-' }}</el-descriptions-item>
              <el-descriptions-item label="紧急联系人">{{ employeeDetailDialog.data.emergency_contact || '-' }}</el-descriptions-item>
              <el-descriptions-item label="紧急联系电话">{{ employeeDetailDialog.data.emergency_phone || '-' }}</el-descriptions-item>
              <el-descriptions-item label="业务领域">
                <div style="white-space: pre-line;">{{ employeeDetailDialog.data.business_areas || '-' }}</div>
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>

          <el-tab-pane label="时间信息" name="time">
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="创建时间">
                {{ formatTime(employeeDetailDialog.data.create_time) }}
              </el-descriptions-item>
              <el-descriptions-item label="更新时间">
                {{ formatTime(employeeDetailDialog.data.update_time) }}
              </el-descriptions-item>
              <el-descriptions-item label="排序">{{ employeeDetailDialog.data.sort }}</el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="employeeDetailDialog.visible = false">关闭</el-button>
        <el-button type="primary" @click="handleEditEmployee(employeeDetailDialog.data)">编辑</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AfuncApi from '@/api/afunc.js';

export default {
  name: 'EmergencyGroup',
  data() {
    return {
      loading: false,
      departmentTree: [],
      allDepartments: [],
      allPosition: [],
      selectedIds: [],
      
      // 右键菜单
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        data: null
      },
      
      // 部门弹窗
      departmentDialog: {
        visible: false,
        title: '添加部门',
        loading: false,
        isEdit: false
      },
      
      // 部门表单
      departmentForm: {
        ma_depart_id: 0,
        parent_id: 0,
        name: '',
        remark: '',
        is_hide: 0,
        sort: 50,
        status: 1
      },
      
      // 部门表单验证
      departmentRules: {
        name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ]
      },
      
      // 部门选项（用于级联选择器）
      departmentOptions: [],
      
      // 详情弹窗
      detailDialog: {
        visible: false,
        data: null
      },
      
      // 员工弹窗
      employeeDialog: {
        visible: false,
        title: '添加员工',
        loading: false,
        isEdit: false
      },
      
      // 员工表单
      
// 员工表单
employeeForm: {
  ma_employee_id: 0,
  ma_depart_id: '',
  ma_position_id:'',
  name: '',
  phone: '',
  gender: 0,
  avatar: '',
  id_card: '',
  political_status: '',
  birthday: '',
  email: '',
  address: '',
  emergency_contact: '',
  emergency_phone: '',
  business_areas: '', // 业务领域代替职位
  status: 1,
  sort: 50
},
      
      // 员工表单验证
      employeeRules: {
        ma_depart_id: [
          { required: true, message: '请选择所属部门', trigger: 'change' }
        ],
        ma_position_id: [ 
          { required: true, message: '请选择所属岗位', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入员工姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        id_card: [
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      
      // 员工详情弹窗
      employeeDetailDialog: {
        visible: false,
        data: null,
        activeTab: 'basic'
      }
    };
  },
  
  created() {
    this.loadDepartments();
    // this.loadEmployees();
    this.loadPosition();
  },
  
  methods: {
    getPositionName(positionId) {
      if (!positionId) return '';
      const position = this.allPosition.find(p => p.ma_position_id === positionId);
      return position ? position.name : '';
    },
    async loadPosition() {
      this.loading = true;
      const response = await AfuncApi.call({
        model: 'ma_position',
        action: 'index', 
      });
      this.allPosition = response.data.list.data
    },
    // 加载部门数据
    // 加载部门数据（一次性获取完整树形结构）
async loadDepartments() {
  try {
    this.loading = true;
    
    // 调用新的接口获取完整树形结构
    const response = await AfuncApi.call({
      model: 'ma_depart',
      action: 'getTreeWithEmployeesV2',  // 新增接口
      is_delete: 0,
      status: 1
    });
    
    if (response.code === 1 && response.data.tree) {
      this.departmentTree = response.data.tree;
      
      // 如果需要平铺的部门列表用于下拉选择
      this.flattenDepartmentsForSelect();
      
      // 构建部门选项
      this.buildDepartmentOptions(this.departmentTree);
    } else {
      // 如果新接口不可用，回退到原来的方法
      // await this.loadDepartmentsFallback();
    }
  } catch (error) {
    console.error('加载部门数据失败:', error);
    // 降级处理
    // await this.loadDepartmentsFallback();
  } finally {
    this.loading = false;
  }
},
    // 扁平化部门用于下拉选择
flattenDepartmentsForSelect() {
  const flatten = (departments, level = 0) => {
    let result = [];
    
    departments.forEach(dept => {
      const prefix = '　'.repeat(level * 2);
      result.push({
        ...dept,
        name: prefix + dept.name + ` (${dept.totalEmployeeCount || dept.employeeCount || 0}人)`,
        ma_depart_id: dept.ma_depart_id
      });
      
      if (dept.children && dept.children.length > 0) {
        result = result.concat(flatten(dept.children, level + 1));
      }
    });
    
    return result;
  };
  
  this.allDepartments = flatten(this.departmentTree);
},
  // 降级方案：原来的方法
// async loadDepartmentsFallback() {
//   try {
//     // 加载部门
//     const deptResponse = await AfuncApi.call({
//       model: 'ma_depart',
//       action: 'index',
//       page: 1,
//       list_rows: 1000,
//       is_delete: 0,
//       status: 1
//     });
    
//     if (deptResponse.code === 1 && deptResponse.data.list) {
//       const departments = deptResponse.data.list.data || [];
//       this.allDepartments = departments;
//       this.buildDepartmentTree(departments);
      
//       // 加载员工
//       await this.loadEmployees();
//     }
//   } catch (error) {
//     console.error('降级方案失败:', error);
//     throw error;
//   }
// },
    // 加载员工数据
    async loadEmployees() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_employee',
          action: 'index',
          page: 1,
          list_rows: 1000,
          is_delete: 0
        });
        
        if (response.code === 1 && response.data.list) {
          const employees = response.data.list.data || [];
          this.attachEmployeesToDepartments(employees);
        }
      } catch (error) {
        console.error('加载员工数据失败:', error);
        this.$message.error('加载员工数据失败');
      }
    },
    
    // 将员工数据附加到部门
 attachEmployeesToDepartments(employees) {
  // 按部门分组
  const employeesByDept = {};
  employees.forEach(emp => {
    const deptId = emp.ma_depart_id;
    if (!employeesByDept[deptId]) {
      employeesByDept[deptId] = [];
    }
    employeesByDept[deptId].push(emp);
  });
  
  // 递归更新部门树
  const updateDepartmentWithEmployees = (departments) => {
    return departments.map(dept => {
      const departmentEmployees = employeesByDept[dept.ma_depart_id] || [];
      return {
        ...dept,
        employees: departmentEmployees,
        employeeCount: departmentEmployees.length,
        children: dept.children ? updateDepartmentWithEmployees(dept.children) : []
      };
    });
  };
  
  this.departmentTree = updateDepartmentWithEmployees(this.departmentTree);
},
    
    // 构建部门树形结构
    // 构建部门树形结构（增强版）
buildDepartmentTree(departments) {
  const tree = [];
  const map = {};
  
  // 创建映射
  departments.forEach(dept => {
    map[dept.ma_depart_id] = { 
      ...dept, 
      children: [], 
      employees: [], 
      employeeCount: 0 
    };
  });
  
  // 构建树
  departments.forEach(dept => {
    const node = map[dept.ma_depart_id];
    if (dept.parent_id === 0) {
      tree.push(node);
    } else if (map[dept.parent_id]) {
      map[dept.parent_id].children.push(node);
    }
  });
  
  this.departmentTree = tree;
  this.buildDepartmentOptions(tree);
  
  // 重新计算每个部门的员工总数（包括子部门的员工）
  this.calculateEmployeeCountForAllDepartments();
},
    // 重新计算所有部门的员工数量（包括子部门的员工）
calculateEmployeeCountForAllDepartments() {
  const calculateCount = (department) => {
    let total = department.employees ? department.employees.length : 0;
    
    if (department.children && department.children.length > 0) {
      department.children.forEach(child => {
        total += calculateCount(child);
      });
    }
    
    // 更新总人数（显示在父部门标签上）
    department.totalEmployeeCount = total;
    return total;
  };
  
  this.departmentTree.forEach(department => {
    calculateCount(department);
  });
},
    // 构建部门选项（用于级联选择器）
   // 构建部门选项（用于级联选择器）
buildDepartmentOptions(tree) {
  const buildOptions = (departments) => {
    return departments.map(dept => {
      const option = {
        ma_depart_id: dept.ma_depart_id,
        name: dept.name + ` (${dept.totalEmployeeCount || dept.employeeCount || 0}人)`,
        children: dept.children ? buildOptions(dept.children) : []
      };
      return option;
    });
  };
  
  this.departmentOptions = buildOptions(this.departmentTree);
},
    // 显示右键菜单
    showContextMenu(event, data) {
      this.contextMenu = {
        visible: true,
        x: event.clientX,
        y: event.clientY,
        data: data
      };
      
      // 点击其他地方关闭菜单
      document.addEventListener('click', this.closeContextMenu);
    },
    
    // 关闭右键菜单
    closeContextMenu() {
      this.contextMenu.visible = false;
      document.removeEventListener('click', this.closeContextMenu);
    },
    
    // 右键菜单 - 编辑
    handleContextEdit() {
      this.handleEditDepartment(this.contextMenu.data);
      this.closeContextMenu();
    },
    
    // 右键菜单 - 删除
    handleContextDelete() {
      this.handleDeleteDepartment(this.contextMenu.data);
      this.closeContextMenu();
    },
    
    // 右键菜单 - 添加子部门
    handleContextAddSub() {
      this.handleAddSubDepartment(this.contextMenu.data);
      this.closeContextMenu();
    },
    
    // 右键菜单 - 添加人员
    handleContextAddEmployee() {
      this.handleAddEmployee(this.contextMenu.data);
      this.closeContextMenu();
    },
    
    // 右键菜单 - 部门详情
    handleContextDetail() {
      this.handleDepartmentDetail(this.contextMenu.data);
      this.closeContextMenu();
    },
    
    // 添加顶级部门
    handleAddTopDepartment() {
      this.departmentDialog = {
        visible: true,
        title: '添加顶级部门',
        loading: false,
        isEdit: false
      };
      
      this.departmentForm = {
        ma_depart_id: 0,
        parent_id: 0,
        name: '',
        remark: '',
        is_hide: 0,
        sort: 50,
        status: 1
      };
    },
    
    // 添加子部门
    handleAddSubDepartment(parent) {
      this.departmentDialog = {
        visible: true,
        title: '添加子部门',
        loading: false,
        isEdit: false
      };
      
      this.departmentForm = {
        ma_depart_id: 0,
        parent_id: parent.ma_depart_id,
        name: '',
        remark: '',
        is_hide: 0,
        sort: 50,
        status: 1
      };
    },
    
    // 编辑部门
    async handleEditDepartment(department) {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'detail',
          ma_depart_id: department.ma_depart_id
        });
        
        if (response.code === 1 && response.data) {
          this.departmentDialog = {
            visible: true,
            title: '编辑部门',
            loading: false,
            isEdit: true
          };
          
          this.departmentForm = {
            ...response.data,
            parent_id: response.data.parent_id || 0
          };
        }
      } catch (error) {
        console.error('获取部门详情失败:', error);
        this.$message.error('获取部门详情失败');
      }
    },
    
    // 删除部门
    handleDeleteDepartment(department) {
      this.$confirm(`确定要删除"${department.name}"吗？删除后该部门下的所有子部门也会被删除`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await AfuncApi.call({
            model: 'ma_depart',
            action: 'del',
            ma_depart_id: department.ma_depart_id
          });
          
          if (response.code === 1) {
            this.$message.success('删除成功');
            this.loadDepartments();
          } else {
            this.$message.error(response.msg || '删除失败');
          }
        } catch (error) {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      });
    },
    
    // 部门详情
    async handleDepartmentDetail(department) {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'detail',
          ma_depart_id: department.ma_depart_id
        });
        
        if (response.code === 1 && response.data) {
          this.detailDialog = {
            visible: true,
            data: response.data
          };
        }
      } catch (error) {
        console.error('获取部门详情失败:', error);
        this.$message.error('获取部门详情失败');
      }
    },
    
    // 提交部门表单
    submitDepartmentForm() {
      this.$refs.departmentForm.validate(async (valid) => {
        if (!valid) return;
        
        this.departmentDialog.loading = true;
        
        try {
          const formData = {
            model: 'ma_depart',
            ...this.departmentForm,
            create_time: this.departmentDialog.isEdit ? undefined : Math.floor(Date.now() / 1000),
            update_time: Math.floor(Date.now() / 1000)
          };
          
          let response;
          if (this.departmentDialog.isEdit) {
            response = await AfuncApi.call({
              ...formData,
              action: 'edit'
            });
          } else {
            response = await AfuncApi.call({
              ...formData,
              action: 'add'
            });
          }
          
          if (response.code === 1) {
            this.$message.success(this.departmentDialog.isEdit ? '修改成功' : '添加成功');
            this.closeDepartmentDialog();
            this.loadDepartments();
          } else {
            this.$message.error(response.msg || '操作失败');
          }
        } catch (error) {
          console.error('操作失败:', error);
          this.$message.error('操作失败');
        } finally {
          this.departmentDialog.loading = false;
        }
      });
    },
    
    // 关闭部门弹窗
    closeDepartmentDialog() {
      this.departmentDialog.visible = false;
      if (this.$refs.departmentForm) {
        this.$refs.departmentForm.clearValidate();
      }
    },
    
    // 添加员工
    handleAddEmployee(department = null) {
      this.employeeDialog = {
        visible: true,
        title: '添加员工',
        loading: false,
        isEdit: false
      };
      
      this.employeeForm = {
        ma_employee_id: 0,
        ma_depart_id: department ? department.ma_depart_id : '',
        ma_position_id: '',
        name: '',
        phone: '',
        gender: 0,
        avatar: '',
        id_card: '',
        political_status: '',
        birthday: '',
        email: '',
        address: '',
        emergency_contact: '',
        emergency_phone: '',
        business_areas: '',
        position: '',
        status: 1,
        sort: 50
      };
      
      if (this.$refs.employeeForm) {
        this.$refs.employeeForm.clearValidate();
      }
    },
    
    // 编辑员工
    async handleEditEmployee(employee) {
      try {
        const response = await AfuncApi.call({
          model: 'ma_employee',
          action: 'detail',
          ma_employee_id: employee.ma_employee_id
        });
        
        if (response.code === 1 && response.data) {
          this.employeeDialog = {
            visible: true,
            title: '编辑员工',
            loading: false,
            isEdit: true
          };
          
          this.employeeForm = {
            ...response.data
          };
        }
      } catch (error) {
        console.error('获取员工详情失败:', error);
        this.$message.error('获取员工详情失败');
      }
    },
    
    // 查看员工详情
    async handleViewEmployeeDetail(employee) {
      try {
        const response = await AfuncApi.call({
          model: 'ma_employee',
          action: 'detail',
          ma_employee_id: employee.ma_employee_id
        });
        
        if (response.code === 1 && response.data) {
          // 获取部门名称
          const department = this.allDepartments.find(d => d.ma_depart_id === response.data.ma_depart_id);
          this.employeeDetailDialog = {
            visible: true,
            data: {
              ...response.data,
              department_name: department ? department.name : ''
            },
            activeTab: 'basic'
          };
        }
      } catch (error) {
        console.error('获取员工详情失败:', error);
        this.$message.error('获取员工详情失败');
      }
    },
    
    // 删除员工
    handleDeleteEmployee(employee) {
      this.$confirm(`确定要删除员工"${employee.name}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await AfuncApi.call({
            model: 'ma_employee',
            action: 'del',
            ma_employee_id: employee.ma_employee_id
          });
          
          if (response.code === 1) {
            this.$message.success('删除成功');
            this.loadDepartments();
          } else {
            this.$message.error(response.msg || '删除失败');
          }
        } catch (error) {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      });
    },
    
    // 提交员工表单
    submitEmployeeForm() {
      this.$refs.employeeForm.validate(async (valid) => {
        if (!valid) return;
        
        this.employeeDialog.loading = true;
        
        try {
          const formData = {
            model: 'ma_employee',
            ...this.employeeForm,
            create_time: this.employeeDialog.isEdit ? undefined : Math.floor(Date.now() / 1000),
            update_time: Math.floor(Date.now() / 1000)
          };
          
          let response;
          if (this.employeeDialog.isEdit) {
            response = await AfuncApi.call({
              ...formData,
              action: 'edit'
            });
          } else {
            response = await AfuncApi.call({
              ...formData,
              action: 'add'
            });
          }
          
          if (response.code === 1) {
            this.$message.success(this.employeeDialog.isEdit ? '修改成功' : '添加成功');
            this.closeEmployeeDialog();
            this.loadDepartments();
          } else {
            this.$message.error(response.msg || '操作失败');
          }
        } catch (error) {
          console.error('操作失败:', error);
          this.$message.error('操作失败');
        } finally {
          this.employeeDialog.loading = false;
        }
      });
    },
    
    // 关闭员工弹窗
    closeEmployeeDialog() {
      this.employeeDialog.visible = false;
      if (this.$refs.employeeForm) {
        this.$refs.employeeForm.clearValidate();
      }
    },
    
    // 编辑公司信息
    editCompanyInfo() {
      this.$message.info('编辑公司信息功能待开发');
    },
    
    // 批量删除
    handleBatchDelete() {
      if (this.selectedIds.length === 0) {
        this.$message.warning('请先选择要删除的部门');
        return;
      }
      
      this.$confirm(`确定要删除选中的 ${this.selectedIds.length} 个部门吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          this.$message.success(`成功删除 ${this.selectedIds.length} 个部门（批量删除功能待实现）`);
          this.selectedIds = [];
        } catch (error) {
          console.error('批量删除失败:', error);
          this.$message.error('批量删除失败');
        }
      });
    },
    
    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000);
      return date.toLocaleString();
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.operation-container {
  margin-bottom: 20px;
}

.company-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.company-title {
  margin: 0;
  color: #333;
  font-size: 24px;
}

.organization-tree {
  min-height: 400px;
}

.loading-container {
  text-align: center;
  padding: 100px 0;
  color: #909399;
}

.empty-container {
  text-align: center;
  padding: 100px 0;
}

.tree-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.department-item {
  margin-bottom: 20px;
}

.department-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s;
}

.department-card:hover {
  box-shadow: 0 4px 16px 0 rgba(0,0,0,0.15);
}

.department-card.is-top {
  border-left: 4px solid #409EFF;
}

.department-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.department-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.department-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.department-actions {
  display: flex;
  gap: 5px;
}

.department-remark {
  color: #666;
  font-size: 13px;
  margin-bottom: 15px;
  padding: 8px;
  background: #f5f7fa;
  border-radius: 4px;
}

.employee-list {
  margin: 10px 0;
}

.employee-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-bottom: 8px;
  background: #f9f9f9;
  border-radius: 6px;
  transition: all 0.3s;
}

.employee-item:hover {
  background: #f0f0f0;
}

.employee-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.employee-details {
  flex: 1;
}

.employee-name {
  font-weight: 500;
  margin-bottom: 2px;
}

.employee-meta {
  display: flex;
  gap: 10px;
  font-size: 12px;
  color: #666;
}

.employee-position {
  color: #409EFF;
}

.employee-phone {
  color: #67C23A;
}

.employee-actions {
  opacity: 0;
  transition: opacity 0.3s;
}

.employee-item:hover .employee-actions {
  opacity: 1;
}

.no-employees {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 13px;
  background: #fafafa;
  border-radius: 4px;
  margin: 10px 0;
}

.sub-department-list {
  border-top: 1px dashed #ebeef5;
  padding-top: 10px;
  margin-top: 15px;
}

.sub-department-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  margin-bottom: 5px;
  background: #f9f9f9;
  border-radius: 4px;
}

.sub-department-item:hover {
  background: #f0f0f0;
}

.sub-department-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sub-department-name {
  font-weight: 500;
}

.sub-department-actions {
  display: flex;
  gap: 5px;
  opacity: 0;
  transition: opacity 0.3s;
}

.sub-department-item:hover .sub-department-actions {
  opacity: 1;
}

/* 右键菜单样式 */
.context-menu {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  padding: 5px 0;
  margin: 0;
  list-style: none;
  min-width: 120px;
}

.context-menu li {
  padding: 8px 15px;
  cursor: pointer;
  transition: all 0.3s;
  color: #606266;
}

.context-menu li:hover {
  background: #f5f7fa;
  color: #409EFF;
}

/* 详情弹窗样式 */
.department-detail-container {
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-title {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #333;
  font-weight: 500;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.remark-content,
.intro-content {
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  line-height: 1.6;
}

/* 员工详情样式 */
.employee-detail-container {
  max-height: 600px;
  overflow-y: auto;
}

.employee-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.employee-header-info {
  flex: 1;
}

.employee-detail-name {
  margin: 0 0 5px 0;
  font-size: 20px;
  color: #333;
}

.employee-detail-position {
  color: #409EFF;
  font-size: 14px;
  margin-bottom: 5px;
}

.employee-detail-department {
  color: #666;
  font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/views/em/emergencygroup.vue